import { BaseModel } from '../../base/base-model'

/**
 * This model is also used for updating
 * a user address in the identity service.
 * Hence, the optional id.
 * @memberOf loavies.models.user
 * @constructor
 */
export class CreateIdentityUserAddressModel extends BaseModel {
  /**
   * @param {string} [id]
   * @param {string} firstName
   * @param {string} lastName
   * @param {string} countryId
   * @param {string} street
   * @param {string} number
   * @param {string} [addition]
   * @param {string} [additionalAddressLine]
   * @param {string} postcode
   * @param {string} city
   * @param {boolean} [defaultShipping]
   */
  constructor({
    id,
    firstName,
    lastName,
    countryId,
    street,
    number,
    addition,
    additionalAddressLine,
    postcode,
    city,
    defaultShipping,
  }) {
    super()
    if (!this.isUndefined(id)) this.id = id

    /** @type {string} */
    this.firstName = firstName

    /** @type {string} */
    this.lastName = lastName

    /** @type {string} */
    this.countryId = countryId

    /** @type {string} */
    this.street = street

    /** @type {string} */
    this.number = number

    /** @type {string} */
    if (!this.isUndefined(addition)) this.addition = addition

    /** @type {string} */
    if (!this.isUndefined(additionalAddressLine)) this.additionalAddressLine = additionalAddressLine

    /** @type {string} */
    this.postcode = postcode

    /** @type {string} */
    this.city = city

    /** @type {boolean} */
    this.defaultShipping = defaultShipping ?? false
  }
}
